import React, { useState, useRef, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import useLaTexCode from "../../../hooks/useLaTexCode";

const Node = ( props ) => {

  const [ chtml, setCHTML ] = useState( '' );

  const container = useRef();

  const mathjax = useSelector( state => state.mathjax );

  const { correctImgCode } = useLaTexCode();

  useEffect( () => {
    if ( mathjax.target ) {
      const correctedImgCode = correctImgCode( props.children );
      const metrics = mathjax.target.getMetricsFor( container.current, true );
      const chtml = mathjax.target.tex2chtml( correctedImgCode, metrics );
      setCHTML( chtml.outerHTML );
    }
  }, [ mathjax.target, props.children ] );

  useEffect( () => {
    if ( chtml ) {
      mathjax.target.typeset();
      mathjax.target.typesetPromise( [ container.current ] ).then( complete );
    }
  }, [ mathjax.target, chtml ] );

  const complete = useCallback( () => {
    props.onRender( container.current, props.index );
  }, [ props.index, props.onRender ] );

  return <div ref={ container } dangerouslySetInnerHTML={ { __html : chtml } } />;

};

Node.defaultProps = {
  onRender : () => {}
};

export default Node;
